import StoryblokClient from "storyblok-js-client"

export default function initializeStoryblokClient(apiKey: string = "") {
  return new StoryblokClient({
    accessToken: apiKey,
    cache: {
      clear: "auto",
      type: "memory",
    },
  })
}
